import { getAnalytics } from "firebase/analytics";
import app from "./Config";

// Initialize Analytics and get a reference to the service
export const analytics = getAnalytics(app);
